'use strict';

var Sugar = require('sugar-core'),
    getWeekNumber = require('./internal/getWeekNumber');

Sugar.Date.defineInstance({

  'getISOWeek': function(date) {
    return getWeekNumber(date, true);
  }

});

module.exports = Sugar.Date.getISOWeek;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/date/getISOWeek.js
// module id = 186
// module chunks = 1